/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Estimated_TotalInputs */

const en_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estimated Total: $${i?.cost} USD`)
};

const fr_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total estimé : $${i?.cost} USD`)
};

const de_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geschätzter Gesamtbetrag: $${i?.cost} USD`)
};

const it_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totale stimato: $${i?.cost} USD`)
};

const ru_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ориентировочная общая сумма: $${i?.cost} USD`)
};

const es_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total estimado: $${i?.cost} USD`)
};

const zh_cn2_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预计总额：$${i?.cost} 美元`)
};

const ja_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`推定合計金額：$${i?.cost} USD`)
};

const hi_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुमानित कुल राशि: $${i?.cost} USD`)
};

const pt_pt2_estimated_total = /** @type {(inputs: Estimated_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total estimado: $${i?.cost} USD`)
};

/**
* | output |
* | --- |
* | "Estimated Total: ${cost} USD" |
*
* @param {Estimated_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const estimated_total = /** @type {((inputs: Estimated_TotalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Estimated_TotalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_estimated_total(inputs)
	if (locale === "de") return de_estimated_total(inputs)
	if (locale === "it") return it_estimated_total(inputs)
	if (locale === "ru") return ru_estimated_total(inputs)
	if (locale === "es") return es_estimated_total(inputs)
	if (locale === "zh-CN") return zh_cn2_estimated_total(inputs)
	if (locale === "ja") return ja_estimated_total(inputs)
	if (locale === "hi") return hi_estimated_total(inputs)
	if (locale === "pt-PT") return pt_pt2_estimated_total(inputs)
	return en_estimated_total(inputs)
});